/* The avatar glyphs alone: going through <Icon> pulled the whole 499-icon set
   (≈210KB gz) onto every page that shows a user. */
import A1 from '@/ui/icons/Icons/avatar_icn_avatar1';
import A2 from '@/ui/icons/Icons/avatar_icn_avatar2';
import A3 from '@/ui/icons/Icons/avatar_icn_avatar3';
import A4 from '@/ui/icons/Icons/avatar_icn_avatar4';
import A5 from '@/ui/icons/Icons/avatar_icn_avatar5';
import A6 from '@/ui/icons/Icons/avatar_icn_avatar6';
import A7 from '@/ui/icons/Icons/avatar_icn_avatar7';
import A8 from '@/ui/icons/Icons/avatar_icn_avatar8';
import A9 from '@/ui/icons/Icons/avatar_icn_avatar9';
import A10 from '@/ui/icons/Icons/avatar_icn_avatar10';
import A11 from '@/ui/icons/Icons/avatar_icn_avatar11';
import A12 from '@/ui/icons/Icons/avatar_icn_avatar12';
import A13 from '@/ui/icons/Icons/avatar_icn_avatar13';
import A14 from '@/ui/icons/Icons/avatar_icn_avatar14';
import A15 from '@/ui/icons/Icons/avatar_icn_avatar15';
import A16 from '@/ui/icons/Icons/avatar_icn_avatar16';
import A17 from '@/ui/icons/Icons/avatar_icn_avatar17';
import A18 from '@/ui/icons/Icons/avatar_icn_avatar18';
import A19 from '@/ui/icons/Icons/avatar_icn_avatar19';
import A20 from '@/ui/icons/Icons/avatar_icn_avatar20';
import A21 from '@/ui/icons/Icons/avatar_icn_avatar21';
import A22 from '@/ui/icons/Icons/avatar_icn_avatar22';

export const AVATAR_GLYPHS = [
  A1,
  A2,
  A3,
  A4,
  A5,
  A6,
  A7,
  A8,
  A9,
  A10,
  A11,
  A12,
  A13,
  A14,
  A15,
  A16,
  A17,
  A18,
  A19,
  A20,
  A21,
  A22,
];
